export const preloadFonts = () => {
  const fonts = [
    {
      href: new URL(
        "@/assets/fonts/maitree-regular-webfont.woff2",
        import.meta.url
      ).href,
      weight: 400,
    },
    {
      href: new URL(
        "@/assets/fonts/maitree-bold-webfont.woff2",
        import.meta.url
      ).href,
      weight: 700,
    },
    {
      href: new URL(
        "@/assets/fonts/itc_avant_garde_gothic_medium-webfont.woff2",
        import.meta.url
      ).href,
      weight: 500,
    },
    {
      href: new URL(
        "@/assets/fonts/itc_avant_garde_gothic_bold-webfont.woff2",
        import.meta.url
      ).href,
      weight: 700,
    },
  ];

  fonts.forEach(({ href, weight }) => {
    if (!document.querySelector(`link[rel="preload"][href="${href}"]`)) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "font";
      link.href = href;
      link.type = "font/woff2";
      link.crossOrigin = "anonymous";
      link.fetchPriority = "high";
      document.head.appendChild(link);
    }
  });
};
